import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  BlockOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import { useMemo } from "react";
import useCollectionsEfficiencyV2 from "../../hooks/useCollectionsEfficiencyV2";
import useDerivedMetricsV2 from "../../hooks/useDerivedMetricsV2";
import {
  HOME_DASHBOARD_COLLECTIONS_CARDS_KPIS,
  HOME_DASHBOARD_ZONES_CARDS_KPIS,
} from "../../utils/constants";
import HomeDivCard from "./HomeDivCard";
import { rankingsDeCategorias, rankingsDeZonas } from "./emAltaHelpers";

export default function HomeDashboardDiv({
  title_high,
  title_low,
  type,
  branchIds,
  periodo,
}) {
  const zonas = useDerivedMetricsV2({
    branchIds,
    ...periodo,
    tipo: "presencial",
    groupBy: "zone",
    enabled: type === "zones",
  });
  const categorias = useCollectionsEfficiencyV2({
    branchIds,
    ...periodo,
    tipo: "presencial",
    enabled: type === "collections",
  });
  const zonesCardsKpisData = useMemo(
    () => rankingsDeZonas(zonas.data),
    [zonas.data]
  );
  const collectionsCardsKpisData = useMemo(
    () => rankingsDeCategorias(categorias.data),
    [categorias.data]
  );

  return (
    <>
      <Col xs={24} md={12} style={{ padding: 16 }}>
        <Card
          title={
            <Row justify="space-between" style={{ width: "100%" }}>
              <Col span={12} style={{ fontSize: 20, fontWeight: 600 }}>
                <ArrowUpOutlined style={{ color: "green", paddingRight: 10 }} />
                {title_high}
              </Col>
              <Col span={12} style={{ fontSize: 20, fontWeight: 600 }}>
                <ArrowDownOutlined style={{ color: "red", paddingRight: 10 }} />
                {title_low}
              </Col>
            </Row>
          }
          style={{
            height: "100%",
            textAlign: "center",
            backgroundColor: "#f8fafc",
          }}
          styles={{
            header: {
              backgroundColor: "var(--ouran-card-header-bg)",
              fontSize: 20,
              fontWeight: 500,
            },
          }}>
          <Row gutter={[16, 16]} style={{ width: "100%" }}>
            {type === "zones" &&
              HOME_DASHBOARD_ZONES_CARDS_KPIS.map((card, index) => (
                <HomeDivCard
                  key={index}
                  title={card?.title}
                  data={zonesCardsKpisData?.[card.group]?.[card.key]}
                  isLoading={zonas.isLoading}
                  group={card.group}
                  cardKey={card.key}
                  icon={<BlockOutlined />}
                />
              ))}
            {type === "collections" &&
              HOME_DASHBOARD_COLLECTIONS_CARDS_KPIS.map((item, index) => (
                <HomeDivCard
                  key={index}
                  title={item.title}
                  data={collectionsCardsKpisData?.[item.group]?.[item.key]}
                  isLoading={categorias.isLoading}
                  group={item.group}
                  cardKey={item.key}
                  icon={<ShoppingOutlined />}
                />
              ))}
          </Row>
        </Card>
      </Col>
    </>
  );
}
